import { render, staticRenderFns } from "./FormFieldRadioGroup.vue?vue&type=template&id=b6bfa332&scoped=true&"
import script from "./FormFieldRadioGroup.vue?vue&type=script&lang=ts&"
export * from "./FormFieldRadioGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bfa332",
  null
  
)

export default component.exports